import * as angular from "angular";
import {IController} from "angular";
import {PoliciesAlertsService} from "../../services/policies-alerts.service";
import {PoliciesRequestsService} from "../../services/policies-requests.service";

export class policyPasswordViewCtrl implements IController {

  extendedPolicy: any;
  orgId: any;
  siteId: any;

  private minScore: any;
  private minlength: any;
  private cidr: any;
  public maxLoginAttemptsBeforeThrottle: number;
  public maxLoginAttemptsFromTheSameIP: number;
  public minutesToCheckSameIpLoginAttempt: number;
  public blockLoginByIpAfterMaximumAttempts: boolean;


  private loading: boolean;

  /* @ngInject */
  constructor(private $log, private policiesRequestsService: PoliciesRequestsService, private policiesAlertsService: PoliciesAlertsService, private splitService) {
  }

  $onInit() {
    this.minScore = this.extendedPolicy.policy.passwordPolicy.minScore;
    this.minlength = this.extendedPolicy.policy.passwordPolicy.minlength;
    this.cidr = this.extendedPolicy.policy.passwordPolicy.cidr;
    this.maxLoginAttemptsBeforeThrottle = this.extendedPolicy.policy.passwordPolicy.maxLoginAttemptsBeforeThrottle;
    this.maxLoginAttemptsFromTheSameIP = this.extendedPolicy.policy.passwordPolicy.maxLoginAttemptsFromTheSameIP;
    this.minutesToCheckSameIpLoginAttempt = this.extendedPolicy.policy.passwordPolicy.minutesToCheckSameIpLoginAttempt;
    this.blockLoginByIpAfterMaximumAttempts = this.extendedPolicy.policy.passwordPolicy.blockLoginByIpAfterMaximumAttempts;
    this.loading = false;
  }

  save(event) {
    this.loading = true;

    const passwordPolicy = {
      minScore: this.minScore,
      minlength: this.minlength,
      cidr: this.cidr,
      maxLoginAttemptsBeforeThrottle: this.maxLoginAttemptsBeforeThrottle,
      maxLoginAttemptsFromTheSameIP: this.maxLoginAttemptsFromTheSameIP,
      minutesToCheckSameIpLoginAttempt: this.minutesToCheckSameIpLoginAttempt,
      blockLoginByIpAfterMaximumAttempts: this.blockLoginByIpAfterMaximumAttempts,
    };

    this.policiesRequestsService.updatePasswordPolicy(this.extendedPolicy.policy.id, passwordPolicy, this.orgId, this.siteId)
      .then((newPasswordPolicy) => {
        this.extendedPolicy.policy.passwordPolicy = newPasswordPolicy;
        if (this.siteId) {
          this.splitService.setSitePasswordPolicy(newPasswordPolicy);
        }
        this.policiesAlertsService.updatePasswordPolicySuccess();
      })
      .catch((error) => {
        this.policiesAlertsService.updatePasswordPolicyError();
        this.$log.error('Failed to update password policy', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

}

angular
  .module('bringoz.admin.policies')
  .component('policyPasswordView', {
    bindings: {
      extendedPolicy: '<',
      orgId: '<?',
      siteId: '<?'
    },
    template: require('./policy-password-view.html').default,
    controller: policyPasswordViewCtrl
  });
